import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'

export const Reviews = ({ data }: { data: any }) => {
  return (
    <section className={data.className + ' max-w-[350px] w-full mx-auto mt-[46px]'}>
      <div className="md:max-w-content">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={12}
          slidesPerView={1}
          loop={false}
          initialSlide={1}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          watchSlidesProgress={true}
          className="reviewSlider !overflow-visible"
        >
          {data.items.map((item: any, index: number) => (
            <SwiperSlide key={index} className="min-h-full !h-[unset]">
              <div className="w-full h-full p-8 bg-boxBg pr-5 rounded-2xl">
                <div className="flex flex-row items-center gap-4 mb-6">
                  <figure className="relative w-14 h-14 rounded-full">
                    <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                  </figure>

                  <div className="flex flex-col">
                    <p className="font-medium mb-1">{item.name}</p>
                    <img width={70} height={14} src="/quiz/icons/stars.svg" alt="image" />
                  </div>
                </div>

                <p className="font-semibold mt-6">{item.title}</p>
                <p className="font-medium opacity-60 mt-2">{item.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}
